<template>
    <div class="page">
        <div class="head-title">
            <div class="left">
                <ul class="breadcrumb">
                    <li>
                        <a href="#" class="active">{{ $t("Property") }}</a>
                    </li>
                    <li>-</li>
                    <li>
                        <router-link to="/property/allcustomers" class="active">{{ $t("all") }} {{ $t("customers") }}
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="main">
            <div class="head">
                <div class="head1">
                    <input type="text" :placeholder="$t('name')" @keypress.enter="namefilter" v-model="name" />
                    {{ $t("Categorie") }} :
                    <select type="text" :placeholder="$t('Categorie')" @change="nameCategorie" v-model="Categorie">
                        <option value="renter">{{ $t("renter") }}</option>
                        <option value="owner">{{ $t("owner") }}</option>
                    </select>
                </div>
                <div class="head2">
                    <button>
                        <router-link to="/property/createowner">+ {{ $t("add") }} {{ $t("customer") }}
                            {{ $t("new") }}</router-link>
                    </button>
                </div>
            </div>
            <div class="body">
                <table class="table">
                    <thead>
                        <tr>
                            <th>{{ $t("code") }}</th>
                            <th>{{ $t("name") }}</th>
                            <th>{{ $t("Categorie") }}</th>
                            <th>{{ $t("mobile") }}</th>
                            <th>{{ $t("type") }} {{ $t("entity") }}</th>
                            <th>{{ $t("type") }} {{ $t("identification") }}</th>
                            <th>{{ $t("number") }} {{ $t("identification") }}</th>
                            <th>{{ $t("date") }}</th>
                            <th>{{ $t("tax") }}</th>

                            <th>{{ $t("address") }}</th>
                            <th>{{ $t("status") }}</th>
                            <th>{{ $t("اجراءات") }}</th>

                            <!-- <th>{{ $t("balance") }}</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="val in data" :key="val">
                            <td>
                                <router-link :to="`/property/allcustomers/customerview/${val.cid}`" class="active">{{
                                    val.cid }}</router-link>
                            </td>
                            <td>
                                <router-link :to="`/property/allcustomers/customerview/${val.cid}`" class="active">{{
                                    val.name }}</router-link>
                            </td>

                            <td>{{ $t(val?.type?? 'N/A') ?? 'N/A'}}</td>
                            <td>{{ val.mobile }}</td>
                            <td>{{ $t(val?.enttype ?? 'N/A') ?? 'N/A' }}</td>
                            <td>{{ $t(val?.idtype?? 'N/A') ?? 'N/A'}}</td>
                            <td>{{ val.idnum }}</td>
                            <td>{{ val.date }}</td>
                            <td>{{ val.taxnumber }}</td>

                            <td>{{ val.address }}</td>
                            <td>{{ $t(val?.review?? 'N/A') ?? 'N/A'}}</td>

                            <td><button @click="del(val.id)" v-if="val.status != 'deleted'">
                                    <i class="bi bi-trash3-fill"></i>
                                </button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
// import store from "@/store";
import axios from "axios";
// import Swal from "sweetalert2";
import { mapActions } from "vuex";
import Swal from "sweetalert2";
// import store from "@/store";

export default {
  props: ["css"],
  components: {},
  data() {
    return {
      name: "",
      status: "",
      mobile: "",
      code: "",
      data: [],
      data2: [],
      Categorie: "",
    };
  },
  async mounted() {
    const result = await axios.get("/data/allcustomer");
    if (result.status == 200) {
      this.data = result.data.data;
      this.data2 = result.data.data;
    }
  },
  methods: {
    del(id) {
      Swal.fire({
        title: this.$t("delete") + " " + this.$t("user"),
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("confirm"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          const action = await axios.delete("/data/deleteUser/" + id);
          if (action.status == 200) {
            Swal.fire(this.$t("delete") + " " + this.$t("user"));
            window.location.reload();
        }
        }
      });
    },
    view(row) {
      this.$root.$router.push({
        path: `/AdminDashboard/JournalEntry/JournalEntryReview/${row.jid}`,
      });
    },
    namefilter() {
      this.data = this.data2.filter((x) => x.name.includes(this.name));
    },
    nameCategorie() {
      this.data = this.data2.filter((x) => x.type.includes(this.Categorie));
    },
    ...mapActions(["redirectTo"]),
  },
  watch: {
    name() {
      this.table.rows = this.table.data.filter((x) =>
        x.namear.includes(this.name.toLowerCase())
      );
    },

    status() {
      this.table.rows = this.table.data.filter((x) => x.review == this.status);
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
    // direction: v-bind("css.EN");
    padding: 0.5%;
}

.main {
    width: 98%;
    margin: 1%;
    padding: 1%;
    // box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    border-radius: 5px;
    border: ridge 0.5px;
}

.head {
    padding: 0.25%;
    display: flex;
    border-bottom-style: ridge;
}

.head1 {
    width: 70%;
}

.head1 input {
    margin: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
}

.head1 select {
    margin: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
}

.head2 {
    width: 30%;
    text-align: center;
}

.head2 button {
    margin: 0.5%;
    padding: 1%;
    border: none;
    border-radius: 5px;
    background-color: rgba(98, 153, 174, 255);
    color: white;
}

.head2 button a {
    color: white;
}

.table {
    margin-top: 1%;
}

table thead tr {
    border-radius: 5px;
    background-color: #eee;
}
</style>
